import Button from 'components/Button';
import { HeadButtons, PageHeadContainer, PageTitle } from 'components/PageHead';
import { FC } from 'react';
import { Link } from 'react-router-dom';

const Head: FC = () => {
  return (
    <PageHeadContainer>
      <PageTitle>
        <h1>Fichiers</h1>
      </PageTitle>
      <HeadButtons>
        <Link to="create">
          <Button color="primary">Ajouter un fichier</Button>
        </Link>
      </HeadButtons>
    </PageHeadContainer>
  );
};

export default Head;
